import { usePeriodDates } from 'src/compass/shared/hooks/usePeriodDates';
import { DateFormat, formatDate } from 'src/compass/shared/util/casMoment';
import prependAllOption from 'src/compass/shared/util/prependAllOption';

export const OPENED_SINCE_THIS_MONTH_AND_UNASSIGNED = 'OpenedSinceThisMonthAndUnassigned';
export const SALES_DASHBOARD_UNASSIGNED = 'SalesDashboardUnassigned';

export default function useNewUnassignedOptions() {
  const { data, isLoading } = usePeriodDates();
  const { currentPeriodStart } = data;

  const currentPeriodMonth = formatDate(currentPeriodStart, DateFormat.MMMM);

  return [
    prependAllOption([
      { name: `Opened in ${currentPeriodMonth}`, id: 'OpenedThisMonth' },
      { name: `Opened in ${currentPeriodMonth} & Unassigned`, id: 'OpenedThisMonthAndUnassigned' },
      {
        name: `Opened since ${currentPeriodMonth} 1`,
        id: 'OpenedSinceThisMonth',
      },
      {
        name: `Opened since ${currentPeriodMonth} 1 & Unassigned`,
        id: OPENED_SINCE_THIS_MONTH_AND_UNASSIGNED,
      },
      { name: 'Sales Dashboard Unassigned', id: SALES_DASHBOARD_UNASSIGNED },
      { name: 'Unassigned', id: 'Unassigned' },
    ]),
    isLoading,
  ];
}
